import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud IVR
 */
const IVRNodeLabel = ({ routingKey, routing, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  const routingId = routingKey === '0' ? 'routing-0' : `routing-${routingKey}`;
  const displayName = routingKey === '0' ? t('START') : (routing.displayName || routing.routingName || routingKey);
  const optionsCount = routing.options ? Object.keys(routing.options).length : 0;
  const isDefaultRouting = routingKey === '0';

  return (
    <div className="node-ivr">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              {t('EDIT')}
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                {t('DELETE')}
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{displayName}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">{t('IVR')}</div>
        <div className="node-info-item">{optionsCount} {t('OPTIONS', { count: optionsCount })}</div>
      </div>
    </div>
  );
};

export default IVRNodeLabel;
